import { LinearProgress, Typography, Box, useTheme } from "@mui/material";

type Props = {
    progress: number;
    total: number;
};

const ImportProgressBar = ({ progress, total }: Props) => {
    const percentage = total > 0 ? Math.round((progress / total) * 100) : 0;
    const theme = useTheme();

    return (
        <Box sx={{ width: "100%", mt: 2 }}>
            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
                {`Progress: ${percentage}% (${progress}/${total} events imported)`}
            </Typography>
            <LinearProgress variant="determinate" value={percentage} />
        </Box>
    );
};

export default ImportProgressBar;